import React from 'react'
import Header from './components/header'
import Csss from './components/Csss'
import About from './components/About'
import Services from './components/Services'
import PriceList from './components/PriceList'
import Principles from './components/Principles'
import Jobs from './components/Jobs'
import Reminders from './components/Reminders'
import KdHajecek from './components/Kd_hajecek'
import News from './components/News'
import Footer from './components/footer'
import { BrowserRouter as Router } from 'react-router-dom'

const App = () => {

  const metaTags = {
    title: 'CSS Sokolov',
    description: 'Centrum sociálních služeb Sokolov, o.p.s',
    keywords: 'pečovatelské služby, sociální služby, pečovatelky',
    image: ''
  }

  return (
    < >
      
      <title>{metaTags.title}</title>
      <meta name="description" content={metaTags.description} />
      <meta name="keywords" content={metaTags.keywords} />
      <meta name="author" content="CSS Sokolov" />
      <meta property="og:title" content={metaTags.title} />
      <meta property="og:description" content={metaTags.description} />
      <meta property="og:image" content="https://example.com/image.jpg" />
      <meta property="og:url" content="https://example.com/my-page" />
      <meta name="twitter:title" content={metaTags.title} />
      <meta name="twitter:description" content={metaTags.description} />
      <meta name="twitter:image" content="https://example.com/image.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      
      <Router>
        <Header/>
        
        <main className='pt-[75px] min-h-[calc(100vh_-_75px)]'>

          <Csss />   
          <About />
          <Services />
          <PriceList />
          <Principles />
          {/* <Jobs /> */}
          <News />
          <Reminders />
        </main>

        <Footer/>
        {/* <KdHajecek /> */}
      </Router>
    </>
  )
}

export default App
